import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TechnicalErrorComponent } from './components/technical-error/technical-error.component';
import { BadRouteComponent } from './shared/Components/bad-route-component';
import { PaymentComponent } from './shared/Components/payment/payment.component';
import { OrderContactComponent } from './components/order-contact/order-contact.component';
import { canActivateAuth } from './guards/auth.guard';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { canActivateCaseAssignment } from './guards/case-assignment.guard';
import { canActivateAuthRole } from './guards/role.guard';
import { Roles } from './shared/Enums/Roles.enum';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: { breadcrumb: '' },
    canActivate: [canActivateAuth],
    children: [
      {
        path: '',
        loadComponent: () => import('./components/case-preview/case-preview.component')
          .then(m => m.CasePreviewComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'cases', role: Roles.PortalCustomer },
      },
      {
        path: 'case-details',
        loadComponent: () => import('./components/case-details/case-details.component')
          .then(m => m.CaseDetailsComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'case-details', role: Roles.PortalCustomer },
      },
      {
        path: 'case-assignment',
        loadComponent: () => import('./components/case-assignment/case-assignment.component')
          .then(m => m.CaseAssignmentComponent),
        canActivate: [canActivateCaseAssignment],
        data: { breadcrumb: 'case-assignment' },
      },
      {
        path: 'order-contact',
        component: OrderContactComponent,
        data: { breadcrumb: 'order-contact', role: Roles.PortalCustomer },
        canActivate: [canActivateAuthRole],
      },
      {
        path: 'case-agreement',
        loadComponent: () => import('./components/case-agreement/case-agreement.component')
          .then(m => m.CaseAgreementComponent),
        data: { breadcrumb: 'case-agreement', role: Roles.PortalCustomer },
        canActivate: [canActivateAuthRole],
      },
      {
        path: 'user-details',
        loadComponent: () => import('./components/user-data-details/user-data-details.component')
          .then(m => m.UserDataDetailsComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'user-details', role: Roles.PortalCustomer },
      },
      {
        path: 'add-address',
        loadComponent: () => import('./components/user-data-details/user-data-details-add-address/user-data-details-add-address.component')
          .then(m => m.UserDataDetailsAddAddressComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'add-address', role: Roles.PortalCustomer },
      },
      {
        path: 'add-phone',
        loadComponent: () => import('./components/user-data-details/user-data-details-add-phone/user-data-details-add-phone.component')
          .then(m => m.UserDataDetailsAddPhoneComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'add-phone', role: Roles.PortalCustomer },
      },
      {
        path: 'add-email',
        loadComponent: () => import('./components/user-data-details/user-data-details-add-email/user-data-details-add-email.component')
          .then(m => m.UserDataDetailsAddEmailComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'add-email', role: Roles.PortalCustomer },
      },
      {
        path: 'payments-history',
        loadComponent: () => import('./components/case-payment-history/case-payment-history.component')
          .then(m => m.CasePaymentHistoryComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'payment-history', role: Roles.PortalCustomer },
      },
      {
        path: 'technical-break',
        loadComponent: () => import('./components/technical-break/technical-break.component')
          .then(m => m.TechnicalBreakComponent),
        data: { breadcrumb: 'technical-break' },
        canActivate: [canActivateAuth],
      },
      {
        path: 'strona-powrotu',
        loadComponent: () => import('./components/payment-return/payment-return.component')
          .then(m => m.PaymentSuccessComponent),
        canActivate: [canActivateAuthRole],
        data: { breadcrumb: 'payment-return', role: Roles.PortalCustomer },
      },
    ],
  },
  {
    path: 'payment',
    component: PaymentComponent,
    data: { breadcrumb: 'payment' },
    canActivate: [canActivateAuth],
  },
  {
    path: 'technical-error',
    component: TechnicalErrorComponent,
    data: { breadcrumb: 'technical-error' },
    canActivate: [canActivateAuth],
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    data: { breadcrumb: 'forbidden' },
    canActivate: [canActivateAuth],
  },
  {
    path: 'bad-route',
    component: BadRouteComponent,
    data: { breadcrumb: 'not-found' },
    canActivate: [canActivateAuth],
  },
  { path: '**', redirectTo: '/bad-route' },
];
